import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ObjectUtils } from 'src/app/@core/utils/object-utils';
import { Nationality } from 'src/app/models/nationality';
import { OnbaseCatalogue } from 'src/app/models/onbase-catalogue';
import { OnbaseEconomicActivity } from 'src/app/models/onbase-economic-activity';
import { NationalityService } from 'src/app/services/nationality.service';
import { OnbaseService } from 'src/app/services/onbase.service';

@Component({
  selector: 'pos-company-information-step',
  templateUrl: './company-information-step.component.html',
  styleUrls: ['./company-information-step.component.sass']
})
export class CompanyInformationStepComponent implements OnInit {

  @Input() companyInformationForm: FormGroup = new FormGroup({
    legalName: new FormControl(""),
    fiscalId: new FormControl(""),
    fiscalIdName: new FormControl(""),
    nationality: new FormControl(""),
    fiscalIdType: new FormControl(""),
    economicActivity: new FormControl(""),
    commercialName: new FormControl(""),
    operationDate: new FormControl(""),
    companySize: new FormControl(""),
    amountEmployees: new FormControl(""),
  });

  nationalities: Array<Nationality> = [];
  economicActivities: Array<OnbaseEconomicActivity> = [];
  companySize: Array<{ key: string, value: string }> = []
  @Input() onbaseCatalogue: OnbaseCatalogue = new OnbaseCatalogue();
  @Input() readonly = false;
  constructor(private nationalityService: NationalityService, private onbaseService: OnbaseService) {


  }

  async ngOnInit(): Promise<void> {
    this.nationalities = (await this.nationalityService.readNationalities().toPromise()).response.content;
    if (this.onbaseCatalogue.economicActivity.length == 0) {
      this.onbaseCatalogue = (await this.onbaseService.readOnBaseCatalogue().toPromise()).response;
    }
    this.economicActivities = this.onbaseCatalogue.economicActivity;
    this.companySize = ObjectUtils.objectToArray(this.onbaseCatalogue.companySize);
  }

}
